//import router from '../router/index'

export default (menus, to = '/') => {
	//debugger
	//Router.options.routes = null
	// 初始路由
	// 初始化路由信息对象
	const menusMap = {}
	//let Url = "GoodsInfo"
	menus.map(v => {
		const {
			id,
			path,
			name,
			component,
			Url,
			redirect,
			hidden,
			meta
		} = v
	
		// 重新构建路由对象
		const item = {
			id,
			path,
			name,
			component,
			//component:() => import(`./pages/${component}`),
			//component: () => import('./pages/GoodsInfo'),
			redirect,
			hidden: JSON.parse(hidden)
		}
		//debugger

       if(meta!=undefined)
	   {
		   meta.length !== 0 && (item.meta = JSON.parse(meta))
	   }
		//if()
		// 判断是否为根节点
		if (v.pid === 0) {
			menusMap[v.id] = item
		} else {
			!menusMap[v.pid].children && (menusMap[v.pid].children = [])
			menusMap[v.pid].children.push(item)
		}
	})
	//debugger
	console.log("menusMap" + JSON.stringify(menusMap))
	return menusMap

	//console.log("integralRoutes" + JSON.stringify(integralRoutes))


	//Router.options.routes = integralRoutes
	//Router.options.routes = routes
	//Router.options.routes = integralRoutes
	//Router.addRoutes(routes)
	//debugger
	// Router.push({
	// 	path: to
	// })
}



// WEBPACK FOOTER //
// ./src/router/parse_routes.js